var d3 = {
  ...require("d3-geo"),
  ...require("d3-selection"),
};
var $ = require("./lib/qsa");
var {geoAlbersUsaPr} = require("./mapUtil.js");

var projection;

var getGeo = async function () {
  var response = await fetch("./assets/synced/states_filtered.json");
  return response.json();
};

var getRoads = async function () {
  var response = await fetch("./assets/synced/ne_10m_roads_small_4.json");
  return response.json();
};

var renderMap = function (config) {
  // Calculate actual chart dimensions
  var chartWidth = Math.min(600, window.innerWidth);
  var chartHeight = Math.ceil(chartWidth / 1.71428571429);

  // Clear existing graphic (for redraw)
  var containerElement = d3.select(config.container);
  containerElement.html("");

  var divisor = chartWidth / 300;
  projection = geoAlbersUsaPr()
    .translate([chartWidth / divisor, chartHeight / divisor]) // translate to center of screen
    .scale(chartWidth + 300 / divisor); // scale things down so see entire US

  var path = d3.geoPath().projection(projection);

  // Create the root SVG element.
  var chartWrapper = containerElement
    .append("div")
    .attr("class", "graphic-wrapper");

  svg = chartWrapper
    .append("svg")
    .attr("id", "map-svg")
    .attr("preserveAspectRatio", "xMidYMid meet")
    .attr("viewBox", "0 0 600 350");
  chartElement = svg.append("g");

  d3.select(".graphic-text").style("opacity", 1);

  var pathStrings = [];
  config.data.forEach(function(g) {
      pathStrings.push(path(g.geometry));
    });
  chartElement
    .append("g")
    .append("path")
    .attr("class", "states on")
    .attr("d", pathStrings.join(" "));
   svg
    .append("rect")
    .attr("mask", "url(#road-mask)")
    .attr("fill", 'rgba(255, 183, 0, .5)')
    .attr("width", '600')
    .attr("height", '350');

  getRoads().then(function (data) {
    data.geometries.forEach(function(g) {
      pathStrings.push(path(g));
    });
    
    chartElement
      .append("g")
      .append("mask")
      .attr("id", "road-mask")
      .append("path")
      .classed("roads", true)
      .attr("d", pathStrings.join(" "));
  });

  createMapCircles(config.obits, chartElement);
};

function moveCircle(index) {
  var circle = $.one("#stay-circle-" + index).firstChild;
  var cx = circle.getAttribute("cx");
  var cy = circle.getAttribute("cy");

  $.one(".circles").setAttribute("transform", `translate(${cx}, ${cy})`);
}

// Add a circle for every person
function createMapCircles(data, chartElement) {
  data.forEach(function (v) {
    v.projection = projection([v.lng, v.lat]);
  });

  var stayCircles = chartElement
    .append("g")
    .selectAll("circle")
    .data(data.filter(d => d.projection))
    .enter();

  var cluster = stayCircles
    .append("g")
    .attr("opacity", "0")
    .style("mix-blend-mode", 'luminosity' )
    .attr("class", "stay-circle")
    .attr("id", (d, i) => "stay-circle-" + i);

  cluster
    .append("circle")
    .attr("mask", "url(#road-mask)")
    .attr("r", "30px")
    .attr("fill", "url('#maskGradient')")
    .attr("cx", (d, i) => d.projection[0])
    .attr("cy", d => d.projection[1]);

  cluster
    .append("circle")
    .attr("r", "2px")
    .attr("fill", "rgb(209, 150, 0)")
    .attr("opacity", 0.5)
    .attr("cx", d => d.projection[0])
    .attr("cy", d => d.projection[1]);
  cluster
    .append("circle")
    .attr("r", "1px")
    .attr("fill", "#fff")
    .attr("opacity", 0.9)
    .attr("cx", d => d.projection[0])
    .attr("cy", d => d.projection[1]);

 var lines = cluster
    .append("g")
    .attr("transform", d => `translate(${d.projection[0]}, ${d.projection[1]})`);
lines
    .append("line")
    .attr("y1", d => -1 * getRandom())
    .attr('y2', d => getRandom())
    .attr("stroke", "rgb(209, 150, 0)")
    .attr("stroke-dasharray", "2,.5")
    .attr("opacity", 0.5);
lines.append("line")
    .attr("x1", d => -1 * getRandom())
    .attr('x2', d => getRandom())
    .attr("stroke", "rgb(209, 150, 0)")
    .attr("stroke-dasharray", "2,.5")
    .attr("opacity", 0.5)
    

  createGlowCircle(chartElement);
}

function getRandom() {
  return 15 * (Math.random() * (1 - .2) + .2);
}

// Add the circle which will move with the new person
// TODO: there must be visual effects to do this instead, look at those.
function createGlowCircle(chartElement) {
  circles = chartElement.append("g").attr("class", "circles");
  circles.attr("opacity", "0");

  circles
    .append("circle")
    .attr("r", "12px")
    .attr("fill", "#111")
    .attr("opacity", 0.5);

  for (let i = 16; i >= 2; i -= 2) {
    circles
      .append("circle")
      .attr("class", "inner-circle-" + i)
      .attr("r", i + "px")
      .attr("fill", `rgb(${255 - i * 3}, ${183 - i * 4}, 0)`);
  }

  circles
    .append("circle")
    .attr("r", "6px")
    .attr("fill", "#fff")
    .attr("opacity", 0.2);
  circles
    .append("circle")
    .attr("r", "4px")
    .attr("fill", "#fff")
    .attr("opacity", 0.4);
  circles
    .append("circle")
    .attr("r", "2px")
    .attr("fill", "#fff")
    .attr("opacity", 0.8);

  // chartElement.append("text").attr("class", "quote").attr("color", "#ccc");
}

module.exports = { getGeo, renderMap, createMapCircles, moveCircle };
